<script>
    import {ICONS} from '../../js/icons.js';
    import Pagination from "../../lib/components/Pagination.svelte";
    import {onMount} from "svelte";
    import moment from "moment";
    import backend from "../../server.js";
    import Loading from "../../lib/components/Loading.svelte";
    import ViewLogs from "../../lib/components/modals/trx/ViewLogs.svelte";
    import FindLogs from "../../lib/components/modals/trx/FindLogs.svelte";
    import alertify from "alertifyjs";
    import Information from "../../lib/components/modals/trx/Information.svelte";
    import {utils, writeFileXLSX} from "xlsx";
    import LogTrace from "../../lib/components/modals/trx/LogTrace.svelte";
    import {getClientsForGroup} from "../../js/clientCurrencyMap.js";

    let transations = { list: [] };
    let filters = { page: 1, xpage: 50, winNotZero: true };
    let loading = false;
    let exportLoading = false;
    let showTrxLogs = false;
    let showFindLogs = false;
    let showTrxInfo = false;
    let showLogTrace = false;
    let logfilter;
    let categories = [];
    let transactionInfo;
    let sessionClientCodes = [];
    let clientOptions = [];
    let clientSearch = '';
    let clientDropdownOpen = false;
    let selectedClient = '';
    let ready = false;

    $: filteredClientOptions = clientOptions.filter(c =>
      c.code.toLowerCase().includes(clientSearch.toLowerCase()) ||
      (c.namesite || '').toLowerCase().includes(clientSearch.toLowerCase())
    );

    function selectClient(code) {
        clientDropdownOpen = false;
        filters.selectedClient = code;
        filters.clientCode = code;
        const opt = clientOptions.find(o => o.code === code);
        clientSearch = opt ? `${opt.namesite} (${opt.code})` : code;
        list();
    }
    const freebets = [
        { value: '', label: 'Todos' },
        { value: 'true', label: 'Si' },
        { value: 'false', label: 'No' }
    ]
    function getClientCodesFromSession() {
        let data = {};
        try { data = JSON.parse(sessionStorage.getItem('user') || '{}'); } catch {}
        if (data.bo_client_codes && data.bo_client_codes.length > 0) return data.bo_client_codes;
        const code = data.client_code || '';
        return getClientsForGroup(code);
    }
    function getClientCodeFromSession() {
        try {
            const u = JSON.parse(sessionStorage.getItem('user') || '{}');
            return u?.client_code;
        } catch { return null; }
    }
    onMount(async () => {
        let actualDate = moment();
        filters.from = actualDate.format("YYYY-MM-DD");
        filters.to = moment().format("YYYY-MM-DD");
        sessionClientCodes = getClientCodesFromSession();
        if (sessionClientCodes.length > 0) {
            filters.selectedClient = sessionClientCodes[0];
            filters.clientCode = sessionClientCodes[0];
        } else {
            filters.clientCode = "";
            filters.selectedClient = "";
        }
        try {
            const codes = sessionClientCodes;
            const res = await backend.client.list({ xpage: 500, page: 1 });
            const list = res.data?.list ?? res.data ?? [];
            clientOptions = codes.map(code => {
                const found = Array.isArray(list) ? list.find(c => c.code === code) : null;
                return { code, namesite: found?.namesite || found?.businessname || code };
            });
            if (filters.selectedClient) {
                const opt = clientOptions.find(o => o.code === filters.selectedClient);
                if (opt) clientSearch = `${opt.namesite} (${opt.code})`;
            }
        } catch {}
        await listCategories(filters.clientCode);

        list();
    });

    const listCategories = async (specificClient = null) => {
        const cid = specificClient || filters.clientCode || getClientCodeFromSession();
        const params = cid ? { clientCode: cid } : {};
        const { data } = await backend.games.listCategories(params);
        categories = (data || []).sort();
    };

    const list = async () => {
        transations.list = [];
        let params = { ...filters, mode: "A" };
        if (!isDateRangeValid()) {
            alertify.error(`El rango entre Desde y Hasta no puede superar ${MAX_DAYS} días.`);
            enforceMaxRangeFromTo();
            loading = false;
            return;
        }
        for (const key in params) {
            if (params[key] === "" || params[key] === null || params[key] === undefined) {
                delete params[key];
            }
        }
        if (!params.winNotZero) delete params.winNotZero;
        loading = true;
        try {
            const chosenClient = params.selectedClient && params.selectedClient !== "" ? params.selectedClient : null;
            if (chosenClient) {
                const requestParams = { ...params, clientCode: chosenClient, page: 1, xpage: filters.xpage };
                delete requestParams.selectedClient;
                const response = await backend.trx.list(requestParams);
                loading = false;
                const data = response.data;
                const originalList = Array.isArray(data.list) ? data.list : [];
                transations = {
                    ...transations,
                    ...data,
                    list: originalList,
                    total: data.total ?? originalList.length
                };
                if (transations.info) {
                    try { transactionInfo = transations.info; } catch (e) { console.error(e); }
                }
                filters.page = 1;
                return;
            }
            if (sessionClientCodes.length > 1) {
                const requests = sessionClientCodes.map(cc => {
                    const p = { ...params, clientCode: cc, page: 1, xpage: filters.xpage };
                    delete p.selectedClient;
                    return backend.trx.list(p)
                        .then(r => ({ code: cc, data: r.data }))
                        .catch(e => ({ code: cc, data: { list: [], total: 0, page: 1, xpage: filters.xpage } }));
                });
                const responses = await Promise.all(requests);
                const mergedMap = new Map();
                let mergedTotal = 0;
                let anyXpage = filters.xpage || 50;
                for (const r of responses) {
                    const listPart = Array.isArray(r.data.list) ? r.data.list : [];
                    for (const item of listPart) { if (!mergedMap.has(item.id)) mergedMap.set(item.id, item); }
                    mergedTotal += Number(r.data.total ?? listPart.length);
                    anyXpage = r.data.xpage ?? anyXpage;
                }
                const mergedList = Array.from(mergedMap.values());
                transations = {
                    list: mergedList,
                    total: mergedTotal,
                    page: 1,
                    xpage: anyXpage
                };
                loading = false;
                filters.page = 1;
                return;
            }
            const requestParams = { ...params };
            if (requestParams.clientCode === "") delete requestParams.clientCode;
            if (requestParams.selectedClient) delete requestParams.selectedClient;
            const response = await backend.trx.list(requestParams);
            loading = false;
            const data = response.data;
            const originalList = Array.isArray(data.list) ? data.list : [];
            transations = {
                ...transations,
                ...data,
                list: originalList,
                total: data.total ?? originalList.length
            };
            if (transations.info) {
                try { transactionInfo = transations.info; } catch (e) { console.error(e); }
            }
        } catch (error) {
            loading = false;
            alertify.error("Error al listar");
            if (transations.list?.game == null) alertify.error("Error: el campo Game es NULL");
        }
        filters.page = 1;
    };
    const filterEnter = (e) => { if (e.charCode === 13) list(); };
    const onPageClick = (page) => {
        filters.page = page;
        list();
    };
    const numAmount = (a) => {
        if (a == null) return NaN;
        if (typeof a === "object") {
            if (a.parsedValue != null) return Number(a.parsedValue);
            if (a.source != null && a.source !== "") {
                const n = Number(a.source);
                if (!Number.isNaN(n)) return n;
            }
        }
        return Number(a);
    };
    const MAX_DAYS = 62;
    function parseDate(d) {
        if (!d) return null;
        const m = moment(d, "YYYY-MM-DD", true);
        return m.isValid() ? m : null;
    }
    function enforceMaxRangeFromTo() {
        const mFrom = parseDate(filters.from);
        let mTo = parseDate(filters.to);
        if (!mFrom) return;
        if (!mTo) {
            filters.to = mFrom.format("YYYY-MM-DD");
            return;
        }
        const maxTo = mFrom.clone().add(MAX_DAYS, "days");
        if (mTo.isAfter(maxTo)) {
            filters.to = maxTo.format("YYYY-MM-DD");
            alertify.warning(`Rango máximo ${MAX_DAYS} días. 'Hasta' ajustado a ${filters.to}`);
        }
    }
    function isDateRangeValid() {
        const mFrom = parseDate(filters.from);
        const mTo = parseDate(filters.to);
        if (!mFrom || !mTo) return true;
        const diffDays = mTo.diff(mFrom, "days");
        return diffDays >= 0 && diffDays <= MAX_DAYS;
    }
    async function fetchAllPagesWithCurrentFilters() {
        const base = { ...filters, mode: "A" };
        for (const k in base) if (base[k] === "") delete base[k];
        const pageSize = 100;
        const all = [];
        const chosenClient = base.selectedClient && base.selectedClient !== "" ? base.selectedClient : null;
        delete base.selectedClient;
        if (chosenClient) {
            const params = { ...base, page: 1, xpage: pageSize, clientCode: chosenClient };
            while (true) {
                const resp = await backend.trx.list(params);
                const data = resp?.data || {};
                const batch = Array.isArray(data.list) ? data.list : [];
                all.push(...batch);
                if (batch.length < pageSize) break;
                params.page += 1;
            }
            return all;
        }
        if (sessionClientCodes.length > 1) {
            for (const cc of sessionClientCodes) {
                const params = { ...base, page: 1, xpage: pageSize, clientCode: cc };
                while (true) {
                    const resp = await backend.trx.list(params);
                    const data = resp?.data || {};
                    const batch = Array.isArray(data.list) ? data.list : [];
                    all.push(...batch);
                    if (batch.length < pageSize) break;
                    params.page += 1;
                }
            }
            return all;
        }
        const cid = base.clientCode;
        const params = { ...base, page: 1, xpage: pageSize };
        if (cid) params.clientCode = cid;
        while (true) {
            const resp = await backend.trx.list(params);
            const data = resp?.data || {};
            const batch = Array.isArray(data.list) ? data.list : [];
            all.push(...batch);
            if (batch.length < pageSize) break;
            params.page += 1;
        }
        return all;
    }

    function applyRightAlignToColumns(ws, colNames = []) {
        const range = utils.decode_range(ws['!ref'] || "A1:A1");
        const firstRow = range.s.r;
        const colIndexes = {};
        for (let C = range.s.c; C <= range.e.c; ++C) {
            const cellAddress = utils.encode_cell({ c: C, r: firstRow });
            const cell = ws[cellAddress];
            if (!cell) continue;
            const header = String(cell.v || "").trim();
            if (colNames.includes(header)) colIndexes[header] = C;
        }
        if (Object.keys(colIndexes).length === 0) return;
        for (let R = firstRow + 1; R <= range.e.r; ++R) {
            for (const header of Object.keys(colIndexes)) {
                const C = colIndexes[header];
                const addr = utils.encode_cell({ c: C, r: R });
                const cell = ws[addr];
                if (!cell) continue;
                if (typeof cell.v === "string" && !isNaN(Number(cell.v))) {
                    cell.v = Number(cell.v);
                    cell.t = 'n';
                }
                cell.s = cell.s || {};
                cell.s.alignment = cell.s.alignment || {};
                cell.s.alignment.horizontal = "right";
            }
        }
    }

    async function exportXLSX() {
        try {
            exportLoading  = true;
            const allRows = await fetchAllPagesWithCurrentFilters();
            const rows = allRows.map((trx) => ({
                ID: trx.id,
                Fecha: moment(trx.date).format("DD/MM/YYYY HH:mm:ss"),
                Usuario: trx?.user?.username_origin ?? "-",
                Sitio: trx?.user?.client?.namesite ?? "",
                Moneda: trx?.user?.currency ?? "",
                "Reference (Trx Id)": trx.trxid ?? "",
                "Trx Asociado": trx.referencebet ?? "",
                "Round ID": trx.serial ?? "",
                Juego: trx?.game ? `${trx.game.name} (${trx.game.gameid})` : "",
                Categoría: trx?.game?.category ?? "",
                Tipo: trx.movement ?? "",
                Monto: Number((numAmount(trx.amount) || 0).toFixed(2)),
                "Nuevo Balance": Number(((trx.balanceaftertrx ?? 0)).toFixed(2)),
            }));
            const ws = utils.json_to_sheet(rows, { cellDates: false });
            ws['!cols'] = [
                { wpx: 50 }, // ID
                { wpx: 150 }, // Fecha
                { wpx: 120 }, // Usuario
                { wpx: 140 }, // Sitio
                { wpx: 60 }, // Moneda
                { wpx: 160 }, // Reference
                { wpx: 120 }, // Trx Asociado
                { wpx: 120 }, // Round ID
                { wpx: 200 }, // Juego
                { wpx: 120 }, // Categoría
                { wpx: 80 }, // Tipo
                { wpx: 100 }, // Monto
                { wpx: 110 }, // Nuevo Balance
            ];
            applyRightAlignToColumns(ws, ["Monto", "Nuevo Balance"]);
            const wb = utils.book_new();
            utils.book_append_sheet(wb, ws, "TRX");
            const fname = `transacciones_${filters.from || "inicio"}_${filters.to || "fin"}.xlsx`;
            writeFileXLSX(wb, fname, { bookType: "xlsx" });
        } catch (e) {
            console.error(e);
            alertify.error("No se pudo exportar el XLSX");
        } finally {
            exportLoading = false;
        }
    }

</script>
<div class="bo-main">
    <div class="bo-filters">
        <div class="bo-filter-grid">
            <div class="bo-field">
                <label for="trx_id">Reference (Trx ID)</label>
                <input id="trx_id" bind:value={filters.trxid} on:keypress={filterEnter} class="form-control" />
            </div>

            <div class="bo-field">
                <label for="trx_ref">Trx Asociado</label>
                <input id="trx_ref" bind:value={filters.referencebet} on:keypress={filterEnter} class="form-control" />
            </div>

            <div class="bo-field">
                <label for="round_id">Round ID</label>
                <input id="round_id" bind:value={filters.serial} on:keypress={filterEnter} class="form-control" />
            </div>

            <div class="bo-field">
                <label for="user">Usuario</label>
                <input id="user" bind:value={filters.username_origin} on:keypress={filterEnter} class="form-control" />
            </div>

            <div class="bo-field">
                <label for="from">Desde</label>
                <input id="from" class="form-control" type="date" bind:value={filters.from}
                       on:change={() => { enforceMaxRangeFromTo(); }} />
            </div>

            <div class="bo-field">
                <label for="to">Hasta</label>
                <input id="to" class="form-control" type="date" bind:value={filters.to}
                       on:change={() => { enforceMaxRangeFromTo(); }} />
            </div>

            <div class="bo-field">
                <label for="game">Juego</label>
                <input id="game" bind:value={filters.gameName} on:keypress={filterEnter} class="form-control" />
            </div>

            <div class="bo-field">
                <label for="categories">Categoría</label>
                <select id="categories" bind:value={filters.category} class="form-control">
                    <option value="">Todos</option>
                    {#each categories as category}
                        <option>{category}</option>
                    {/each}
                </select>
            </div>

            <div class="bo-field">
                <label for="movement_type">Tipo de movimiento</label>
                <select id="movement_type" bind:value={filters.movement} class="form-control">
                    <option value="">Todos</option>
                    <option value="BET">BET</option>
                    <option value="WIN">WIN</option>
                    <option value="REFUND">REFUND</option>
                </select>
            </div>
            <div class="bo-field">
                <label for="movement_type">Apuestas Gratis</label>
                <select id="movement_type" bind:value={filters.freebet} class="form-control">
                    {#each freebets as freebet }
                        <option value={freebet.value}>{freebet.label}</option>
                    {/each}
                </select>
            </div>
            {#if sessionClientCodes.length > 1}
                <div class="bo-field" style="position:relative;">
                    <label for="clientSearch">Filtrar sitio</label>
                    <input id="clientSearch" class="form-control" type="text"
                           bind:value={clientSearch}
                           on:focus={() => { clientDropdownOpen = true; clientSearch = ''; }}
                           on:blur={() => setTimeout(() => {
                               clientDropdownOpen = false;
                               if (filters.selectedClient) {
                                   const opt = clientOptions.find(o => o.code === filters.selectedClient);
                                   if (opt) clientSearch = `${opt.namesite} (${opt.code})`;
                               }
                           }, 200)}
                           placeholder="Buscar sitio..." />
                    {#if clientDropdownOpen && filteredClientOptions.length > 0}
                        <div class="search-dropdown">
                            {#each filteredClientOptions as opt}
                                <button class="search-dropdown-item" class:active={opt.code === filters.selectedClient}
                                        on:mousedown={() => selectClient(opt.code)}>
                                    <span class="opt-name">{opt.namesite}</span>
                                    <span class="opt-code">{opt.code}</span>
                                </button>
                            {/each}
                        </div>
                    {/if}
                </div>
            {/if}
            
            <!-- Acciones -->
            <div class="bo-actions">
                <button on:click={list} class="btn btn-primary btn-sm btn-icon" title="Buscar">
                    {@html ICONS.search}
                </button>
                <button on:click={exportXLSX} class="btn btn-success btn-sm" disabled={exportLoading}>
                    {exportLoading ? 'Exportando...' : 'Exportar en Excel'}
                </button>
            </div>
        </div>
    </div>
    <div class="bo-body-table-trx">
        <Loading bind:loading />
        {#if !loading}
            <div style="overflow-x: auto;">
                <table id="myTable" class="table table-striped table-sm">
                    <thead class="table-dark">
                    <tr class="bo-table-title">
                        <th title="transaction.Id">ID</th>
                        <th>Fecha</th>
                        <th>Usuario</th>
                        <th>Sitio</th>
                        <th>Moneda</th>
                        <th title="trxId">Reference (Trx Id)</th>
                        <th title="trxId">Trx Asociado</th>
                        <th>Round ID</th>
                        <th>Juego</th>
                        <th>Categoría</th>
                        <th>Gratis</th>
                        <th>Tipo</th>
                        <th class="col-num">Monto</th>
                        <th class="col-num">Nuevo Balance</th>
                        <!--<th>Opciones</th>-->
                    </tr>
                    </thead>
                    <tbody>
                    {#if transations.list.length}
                        {#each transations.list as trx}
                            <tr class="bo-table-data">
                                <td>{trx.id}</td>
                                <td>{moment(trx.date).format("DD/MM/YYYY HH:mm:ss")}</td>
                                <td>
                                    {#if trx.user}
                                        {trx.user.username_origin}
                                    {:else}
                                        -
                                    {/if}
                                </td>
                                <td>{trx.user.client.namesite}</td>
                                <td>{trx.user.currency}</td>
                                <td>{trx.trxid}</td>
                                <td>{trx.referencebet || ""}</td>
                                <td>{trx.serial}</td>
                                {#if trx.game != null}
                                    <td>{trx.game.name}</td>
                                    <td>{trx.game.category}</td>
                                {:else}<td style="color: red;">FALTA INFORMACIÓN</td>
                                {/if}
                                <!--<td>Test</td>-->
                                <td>{trx.freebet == true? "SI": "NO"}</td>
                                <td><p class={trx.movement == 'BET' ? "text-red" : "text-green"}>{trx.movement}</p></td>
                                <td class="col-num">
                                    <p class={trx.amount < 0 ? "text-red" : "text-green"}>{trx.amount.toFixed(2)}</p>
                                </td>
                                <td class="col-num fw-bold">{trx.balanceaftertrx?.toFixed(2)}</td>
                                <!--<td class="btn-options">
                                    <button on:click={onLogsByTrx(trx)} class="btn btn-secondary btn-sm" title="Registros">{@html ICONS.eye}</button>
                                    {#if trx.game.category === "sportbook"}
                                        <button on:click={onInfoByTrx(trx)} class="btn btn-light btn-sm" title="Información de deportivas">{@html ICONS.clipboard}</button>
                                    {/if}
                                </td>-->
                            </tr>
                        {/each}
                    {:else}
                        <tr class="bo-table-data">
                            <td colspan="14">No se encontraron registros</td>
                        </tr>
                    {/if}
                    </tbody>
                </table>
            </div>
            {#if transations.list.length}
                <Pagination
                        bind:total={transations.total}
                        bind:xpage={transations.xpage}
                        bind:current={transations.page}
                        {onPageClick}
                />
            {/if}
        {/if}
    </div>
</div>

{#if showTrxLogs}
    <ViewLogs bind:showTrxLogs bind:logfilter />
{/if}
{#if showFindLogs}
    <FindLogs bind:showFindLogs />
{/if}

{#if showTrxInfo}
    <Information bind:showTrxInfo bind:transactionInfo />
{/if}

{#if showLogTrace}
    <LogTrace bind:showLogTrace bind:logfilter />
{/if}

<style>
    :root {
        --gap-sm: 0.4rem;
        --gap-md: 0.6rem;
        --gap-lg: 1rem;
        --control-h: 36px;
    }
    *,
    *::before,
    *::after { box-sizing: border-box; }
    .bo-main {
        padding: 1rem;
        display: flex;
        flex-direction: column;
        gap: var(--gap-lg);
    }
    .bo-filters {
        padding: 0.5rem 0.5rem 0;
    }
    .bo-filter-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: var(--gap-md);
    }
    .bo-field {
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
        min-width: 0;
    }
    .bo-field > label {
        font-size: 0.8rem;
        color: #444;
        line-height: 1;
    }
    .bo-field .form-control {
        height: var(--control-h);
    }
    .bo-actions {
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        gap: var(--gap-sm);
        padding-top: 0.2rem;
    }
    .bo-actions .btn.btn-sm {
        height: var(--control-h);
        min-width: 44px;
    }
    .btn-icon {
        display: inline-grid;
        place-items: center;
        width: var(--control-h);
        padding: 0;
    }
    .table.table-sm th {
        padding: 0.4rem 0.6rem;
    }
    .table.table-sm td {
        padding: 0.55rem 0.6rem;
    }
    thead.table-dark {
        position: sticky;
        top: 0;
        z-index: 1;
    }
    .bo-table-title {
        text-align: center;
        font-size: 0.8rem;
        background-color: rgb(158, 93, 80);
        color: #fff;
        border: 1px solid #000;
    }
    .bo-table-data {
        text-align: center;
        font-size: 0.8rem;
    }
    .col-num {
        font-variant-numeric: tabular-nums;
        text-align: right;
    }
    .col-num p {
        margin: 0;
        text-align: right;
    }
    .text-red { color: red; }
    .text-green { color: green; }
    .bo-body-table-trx {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        position: relative;
    }
    .search-dropdown {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: #fff;
        border: 1px solid #ced4da;
        border-radius: 0.3rem;
        max-height: 220px;
        overflow-y: auto;
        z-index: 100;
        box-shadow: 0 4px 12px rgba(0,0,0,0.12);
    }
    .search-dropdown-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 0.4rem 0.6rem;
        border: none;
        background: none;
        cursor: pointer;
        font-size: 0.82rem;
        text-align: left;
    }
    .search-dropdown-item:hover,
    .search-dropdown-item.active { background: #f0f0f0; }
    .opt-name { font-weight: 600; color: #212529; }
    .opt-code { color: #0d6efd; font-size: 0.75rem; font-family: monospace; }
</style>
